var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelPart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.498,
    cy: 14.83,
    fill: "#FFF",
    rx: 5.865,
    ry: 5.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.498,
    cy: 9.83,
    fill: "#FFF",
    rx: 5.865,
    ry: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.12 6.911l-5.084 5.703"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M13.036 6.91l5.084 5.704-5.084-5.703z"
  }))));
}
export default SvgCancelPart;